import React, {Component} from 'react';
import {Label} from 'semantic-ui-react';

class TicketExpirationDays extends Component {
    render() {
        return (
            this.props.has_expiration ? <Label color='orange'>{this.props.expiration_days} días</Label>:'No Caduca'
        );
    }
}
export default TicketExpirationDays;



// WEBPACK FOOTER //
// ./src/components/services/TicketExpirationDays.js